import * as Yup from 'yup';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { socialHabits } from '../../utils/constants';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const PvESocialHabits = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const socialHabitsOptions = createLocalizedOptions(socialHabits, messages);

  useEffect(() => {
    const PvESocialHabitsSchema = {
      socialHabitCoopIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(PvESocialHabitsSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="socialHabitCoopIds"
      label={intl.formatMessage({ ...messages.socialHabitsCoop })}
      isMulti={true}
      options={socialHabitsOptions}
      value={values.socialHabitCoopIds}
      error={errors.socialHabitCoopIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default PvESocialHabits;
